import React from 'react';
import Icon from '../../../components/dashboard/DashboardIcons';

const fieldCls = 'mt-1 block rounded-lg border border-slate-200 bg-white px-2 py-2 text-sm text-slate-700 outline-none focus:border-teal-400';

export default function FilterBar({ draft, setDraft, onApply, onReset, showTeamCategory, teams = [], categories = [] }) {
  return (
    <div className="flex flex-wrap items-end gap-3 rounded-xl border border-slate-200 bg-white p-3 print:hidden" data-testid="reports-filter-bar">
      <label className="text-xs text-slate-500">
        من تاريخ
        <input type="date" value={draft.date_from} onChange={(e) => setDraft((d) => ({ ...d, date_from: e.target.value }))} className={fieldCls} data-testid="reports-filter-from" />
      </label>
      <label className="text-xs text-slate-500">
        إلى تاريخ
        <input type="date" value={draft.date_to} onChange={(e) => setDraft((d) => ({ ...d, date_to: e.target.value }))} className={fieldCls} data-testid="reports-filter-to" />
      </label>
      {showTeamCategory && (
        <>
          <label className="text-xs text-slate-500">
            الفريق
            <select value={draft.team_id} onChange={(e) => setDraft((d) => ({ ...d, team_id: e.target.value }))} className={fieldCls} data-testid="reports-filter-team">
              <option value="">كل الفرق</option>
              {teams.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </label>
          <label className="text-xs text-slate-500">
            الفئة
            <select value={draft.category_id} onChange={(e) => setDraft((d) => ({ ...d, category_id: e.target.value }))} className={fieldCls} data-testid="reports-filter-category">
              <option value="">كل الفئات</option>
              {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </label>
        </>
      )}
      <button onClick={onApply} className="flex items-center gap-2 rounded-lg bg-[#16233b] px-4 py-2 text-sm font-semibold text-white hover:bg-[#1e2f4e]" data-testid="reports-filter-apply">
        <Icon name="check" className="w-4 h-4" /> تطبيق
      </button>
      <button onClick={onReset} className="rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-600 hover:border-teal-300" data-testid="reports-filter-reset">
        إعادة ضبط
      </button>
    </div>
  );
}
